// import React, { useEffect, useState } from "react";
// import {
//   Routes,
//   Route,
//   Navigate,
//   useNavigate,
//   useLocation,
// } from "react-router-dom";
// import { DndProvider } from "react-dnd";
// import { HTML5Backend } from "react-dnd-html5-backend";
// import ReactGA from "react-ga4";
// import { ToastContainer } from "react-toastify";
// import { useTheme } from "./context/ThemeContext";

// // Context & Tracking
// import PrivateRoute from "./privateRoute";
// import usePageTracking from "./usePageTracking";
// import useTimeTracking from "./PageLayout";
// import { DistrictProvider } from "./utils/DistrictContext";

// // New Layout Components
// import { Sidebar } from "./components/layout/sidebar";
// import { Header } from "./components/layout/Headernav";

// // Page Imports
// import Login from "./components/layout/Login";
// import McCORD_Login from "./pages/McCORD_Login";
// import Home from "./pages/Home";
// // import Water from "./pages/Water";
// import Waters from "./pages/Waters";
// import Watersold from "./pages/Watersold";
// import Listuser from "./pages/Listuser";
// import Healthstatus from "./pages/Healthstatus";
// import TotalFlow from "./pages/TotalFlow";
// import FlowHealth from "./pages/FlowHealth";
// import Schematics from "./pages/Schematics";
// import Outliersnew from "./pages/Outliersnew";
// import ResetPassword from "./components/layout/ResetPassword";
// import Profile from "./pages/Profile";
// import Alerts from "./pages/Alert";
// import MeterLeakDetail from "./pages/MeterLeakDetail";
// // import WaterCombined from "./pages/WaterCombined";
// import DroughtDashboard from "./pages/DroughtDashboard";
// import RuleConfigurations from "./pages/RuleConfigurations";
// import ViolationDetails from "./pages/ViolationDetails";

// // Styles
// import "react-toastify/dist/ReactToastify.css";


// function App() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isDragMode, setIsDragMode] = useState(false);
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const { colors } = useTheme();

//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 767);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Determine if we should show the sidebar (hide on login)
//   const authRoutes = ["/login", "/reset", "/resetpassword"];
//   const showSidebar = !authRoutes.includes(location.pathname);

//   ReactGA.set({ debug_mode: true });
//   usePageTracking();
//   useTimeTracking();

//   useEffect(() => {
//     const title =
//       window.location.href.indexOf("mizuwatch.com") > -1
//         ? "MizuWatch"
//         : "MizuSmart";
//     document.title = title;
//   }, []);

//   // Sync active sidebar item with current URL path
//   const activeItem = location.pathname.substring(1) || "dashboard";

//   const handleSidebarClick = (item) => {
//     // Map sidebar IDs to your actual routes
//     if (item === "home") navigate("/dashboard");
//     else if (item === "water-usage") navigate("/waters");
//     else if (item === "analytics") navigate("/totalflow");
//     else if (item === "digital-twin") navigate("/schematics");
//     else if (item === "reports-alerts") navigate("/alert");
//     else if (item === "account-settings") navigate("/settingsuser");
//     else navigate(`/${item}`);
//   };

//   // scroll style
//   useEffect(() => {
//     // Set scrollbar styles dynamically based on the theme colors
//     const updateScrollbarStyles = () => {
//       document.documentElement.style.setProperty(
//         "--scrollbar-track-color",
//         colors.cardBg, // Use the background color of the current theme
//       );
//       document.documentElement.style.setProperty(
//         "--scrollbar-thumb-color",
//         `linear-gradient(180deg, ${colors.primary}, ${colors.secondary})`, // Adjust based on your primary/secondary color
//       );
//       document.documentElement.style.setProperty(
//         "--scrollbar-thumb-hover-color",
//         `linear-gradient(180deg, ${colors.hoverPrimary}, ${colors.hoverSecondary})`,
//       );
//     };

//     updateScrollbarStyles();
//   }, [colors]);

//   // end scroll style

//   useEffect(() => {
//     const closeHandler = () => setIsSidebarCollapsed(true);

//     window.addEventListener("closeSidebar", closeHandler);

//     return () => window.removeEventListener("closeSidebar", closeHandler);
//   }, []);

//   return (
//     <DndProvider backend={HTML5Backend}>
//       <div className="min-h-screen bg-[#0a1628]">
//         <ToastContainer position="top-right" autoClose={3000} theme="light" />

//         <DistrictProvider>
//           {/* FIXED SIDEBAR */}
//           {/* FIXED SIDEBAR */}
//           {showSidebar && (
//             <>
//               {/* SIDEBAR */}
//               <div
//                 className={`
//         fixed left-0 top-0 h-screen z-50 transition-all duration-300
//         ${
//           isMobile
//             ? isSidebarCollapsed
//               ? "-translate-x-full w-64"
//               : "translate-x-0 w-64"
//             : isSidebarCollapsed
//               ? "w-20"
//               : "w-64"
//         }
//       `}
//               >
//                 <Sidebar
//                   activeItem={activeItem}
//                   onItemClick={handleSidebarClick}
//                   isCollapsed={isSidebarCollapsed}
//                    isMobile={isMobile}
//   closeSidebar={() => setIsSidebarCollapsed(true)}
//                 />
//               </div>

//               {/* OVERLAY (ONLY MOBILE) */}
//               {isMobile && !isSidebarCollapsed && (
//                 <div
//                   className="fixed inset-0 bg-black/40 z-40"
//                   onClick={() => setIsSidebarCollapsed(true)}
//                 />
//               )}
//             </>
//           )}

//           {/* RIGHT SIDE LAYOUT */}
//           <div
//             className={`min-h-screen flex flex-col transition-all duration-300 ${
//               showSidebar
//                 ? window.innerWidth <= 767
//                   ? ""
//                   : isSidebarCollapsed
//                     ? "ml-20"
//                     : "ml-64"
//                 : ""
//             }`}
//           >
//             {/* FIXED HEADER */}
//             {showSidebar && (
//               <div
//                 className={`
//       fixed top-0 right-0 z-30 transition-all duration-300
//       ${
//         isMobile
//           ? "left-0" // FULL WIDTH ON MOBILE ✅
//           : isSidebarCollapsed
//             ? "left-20"
//             : "left-64"
//       }
//     `}
//               >
//                 <Header
//                   isDragMode={isDragMode}
//                   onToggleDragMode={() => setIsDragMode(!isDragMode)}
//                   isSidebarCollapsed={isSidebarCollapsed}
//                   onToggleSidebar={(value) => {
//                     if (typeof value === "boolean") {
//                       setIsSidebarCollapsed(value);
//                     } else {
//                       setIsSidebarCollapsed((prev) => !prev);
//                     }
//                   }}
//                 />
//               </div>
//             )}

//             {/* SCROLLABLE CONTENT */}
//             <main
//               className={`flex-1 transition-all duration-300 ${
//                 showSidebar ? "pt-24 px-6 max-[567px]:px-2" : ""
//               } ${
//                 showSidebar
//                   ? isMobile
//                     ? ""
//                     : isSidebarCollapsed
//                       ? "ml-0"
//                       : "ml-0"
//                   : ""
//               }`}
//               style={{
//                 backgroundColor: colors.background,
//                 transition: "background-color 0.3s ease",
//               }}
//             >
//               <Routes>
//                 <Route path="/login" element={<Login />} />

//                 <Route
//                   path="/resetpassword"
//                   element={
//                     <PrivateRoute>
//                       <McCORD_Login />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route
//                   path="/dashboard"
//                   element={
//                     <PrivateRoute>
//                       <Home isDragMode={isDragMode} />
//                     </PrivateRoute>
//                   }
//                 />
                
//                 <Route
//                   path="/waters"
//                   element={
//                     <PrivateRoute>
//                       <Waters />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route path="/watersold" element={
//                   <PrivateRoute>
//                     < Watersold />
//                   </PrivateRoute>
//                 } />
//                 {/* <Route
//                   path="/waterscombined"
//                   element={
//                     <PrivateRoute>
//                       <WaterCombined />
//                     </PrivateRoute>
//                   }
//                 /> */}
//                 <Route
//                   path="/drought-dashboard"
//                   element={
//                     <PrivateRoute>
//                       <DroughtDashboard />
//                     </PrivateRoute>
//                   }
//                 />

//                   <Route
//                   path="/rule-configuration"
//                   element={
//                     <PrivateRoute>
//                       <RuleConfigurations />
//                     </PrivateRoute>
//                   }
//                 />
//                   <Route path="/violation-details" element={
//                     <PrivateRoute>
//                       <ViolationDetails />
//                     </PrivateRoute>
//                   } />
                
//                 <Route
//                   path="/settingsuser"
//                   element={
//                     <PrivateRoute>
//                       <Listuser />
//                     </PrivateRoute>
//                   }
//                 />
               
//                 <Route
//                   path="/health"
//                   element={
//                     <PrivateRoute>
//                       <Healthstatus />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route
//                   path="/totalflow"
//                   element={
//                     <PrivateRoute>
//                       <TotalFlow />
//                     </PrivateRoute>
//                   }
//                 />
//                 <Route
//                   path="/flow-health"
//                   element={
//                     <PrivateRoute>
//                       <FlowHealth />
//                     </PrivateRoute>
//                   }
//                 />
                
//                 <Route
//                   path="/schematics"
//                   element={
//                     <PrivateRoute>
//                       <Schematics />
//                     </PrivateRoute>
//                   }
//                 />
                
//                 <Route
//                   path="/outliersnew"
//                   element={
//                     <PrivateRoute>
//                       <Outliersnew />
//                     </PrivateRoute>
//                   }
//                 />
               
//                 <Route
//                   path="/reset"
//                   element={
//                     <PrivateRoute>
//                       <ResetPassword />
//                     </PrivateRoute>
//                   }
//                 />
                
//                 <Route
//                   path="/profile"
//                   element={
//                     <PrivateRoute>
//                       <Profile />
//                     </PrivateRoute>
//                   }
//                 />
               
//                 <Route
//                   path="/alert"
//                   element={
//                     <PrivateRoute>
//                       <Alerts />
//                     </PrivateRoute>
//                   }
//                 />
                
//                 <Route
//                   path="/meter-leak-details"
//                   element={
//                     <PrivateRoute>
//                       <MeterLeakDetail />
//                     </PrivateRoute>
//                   }
//                 />

//                 <Route path="*" element={<Navigate to="/login" replace />} />
//               </Routes>
//             </main>
//           </div>
//         </DistrictProvider>
//       </div>
//     </DndProvider>
//   );
// }

// export default App;



import React, { useEffect, useState, Suspense } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReactGA from "react-ga4";
import { ToastContainer } from "react-toastify";
import { useTheme } from "./context/ThemeContext";
import { Spin } from "antd";

// Context & Tracking
import PrivateRoute from "./privateRoute";
import usePageTracking from "./usePageTracking";
import useTimeTracking from "./PageLayout";
import { DistrictProvider } from "./utils/DistrictContext";

// New Layout Components
import { Sidebar } from "./components/layout/sidebar";
import { Header } from "./components/layout/Headernav";
import ChatbotWidget from "./components/layout/ChatbotWidget";

// Static Page Imports (Kept eager for optimized initial login/auth rendering performance)
import Login from "./components/layout/Login";
import ResetPassword from "./components/layout/ResetPassword";

// ⚡ LAZY LOADED PAGES (Code Splitting)
const McCORD_Login = React.lazy(() => import("./pages/McCORD_Login"));
const Home = React.lazy(() => import("./pages/Home"));
const Waters = React.lazy(() => import("./pages/Waters"));
const Watersold = React.lazy(() => import("./pages/Watersold"));
const Listuser = React.lazy(() => import("./pages/Listuser"));
const Healthstatus = React.lazy(() => import("./pages/Healthstatus"));
const TotalFlow = React.lazy(() => import("./pages/TotalFlow"));
const FlowHealth = React.lazy(() => import("./pages/FlowHealth"));
const Schematics = React.lazy(() => import("./pages/Schematics"));
const Outliersnew = React.lazy(() => import("./pages/Outliersnew"));
const Profile = React.lazy(() => import("./pages/Profile"));
const Alerts = React.lazy(() => import("./pages/Alert"));
const MeterLeakDetail = React.lazy(() => import("./pages/MeterLeakDetail"));
const LeakFlowCategory = React.lazy(() => import("./pages/LeakFlowCategory"));
const DroughtDashboard = React.lazy(() => import("./pages/DroughtDashboard"));
const RuleConfigurations = React.lazy(() => import("./pages/RuleConfigurations"));
const ViolationDetails = React.lazy(() => import("./pages/ViolationDetails"));
const DroughtReport = React.lazy(() => import("./pages/DroughtReport"));
const WaterCombined = React.lazy(() => import("./pages/WaterCombined"));
const DroughtExemption = React.lazy(() => import("./pages/DroughtExemption"));
const ReportsAndAlerts = React.lazy(() => import("./pages/reportsandalerts"));

// Styles
import "react-toastify/dist/ReactToastify.css";

// Reusable Loading Placeholder for Lazy Components
const PageFallbackLoader = () => (
  <div className="w-full h-[50vh] flex flex-col items-center justify-center gap-3">
    <Spin size="large" />
    <span className="text-sm text-slate-400 font-medium opacity-60">Loading View...</span>
  </div>
);

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDragMode, setIsDragMode] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const { colors } = useTheme();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine if we should show the sidebar (hide on login)
  const authRoutes = ["/login", "/reset", "/resetpassword"];
  const showSidebar = !authRoutes.includes(location.pathname);

  ReactGA.set({ debug_mode: true });
  usePageTracking();
  useTimeTracking();

  useEffect(() => {
    const title =
      window.location.href.indexOf("mizuwatch.com") > -1
        ? "MizuWatch"
        : "MizuSmart";
    document.title = title;
  }, []);

  // Sync active sidebar item with current URL path
  const activeItem = location.pathname.substring(1) || "dashboard";

  const handleSidebarClick = (item) => {
    // Map sidebar IDs to your actual routes
    if (item === "home") navigate("/dashboard");
    else if (item === "water-usage") navigate("/waters");
    else if (item === "analytics") navigate("/totalflow");
    else if (item === "digital-twin") navigate("/schematics");
    else if (item === "reports-alerts") navigate("/alert");
    else if (item === "account-settings") navigate("/settingsuser");
    else navigate(`/${item}`);
  };

  // scroll style
  useEffect(() => {
    // Set scrollbar styles dynamically based on the theme colors
    const updateScrollbarStyles = () => {
      document.documentElement.style.setProperty(
        "--scrollbar-track-color",
        colors.cardBg
      );
      document.documentElement.style.setProperty(
        "--scrollbar-thumb-color",
        `linear-gradient(180deg, ${colors.primary}, ${colors.secondary})`
      );
      // scrollbar-color (Firefox/standard) only accepts a plain color, not
      // a gradient, unlike the ::-webkit-scrollbar-thumb background above.
      document.documentElement.style.setProperty(
        "--scrollbar-thumb-solid-color",
        colors.primary
      );
      document.documentElement.style.setProperty(
        "--scrollbar-thumb-hover-color",
        `linear-gradient(180deg, ${colors.hoverPrimary}, ${colors.hoverSecondary})`
      );
    };

    updateScrollbarStyles();
  }, [colors]);

  useEffect(() => {
    const closeHandler = () => setIsSidebarCollapsed(true);
    window.addEventListener("closeSidebar", closeHandler);
    return () => window.removeEventListener("closeSidebar", closeHandler);
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="min-h-screen bg-[#0a1628]">
        <ToastContainer position="top-right" autoClose={3000} theme="light" />

        <DistrictProvider>
          {/* FIXED SIDEBAR */}
          {showSidebar && (
            <>
              <div
                className={`
                  fixed left-0 top-0 h-screen z-50 transition-all duration-300
                  ${isMobile
                    ? isSidebarCollapsed ? "-translate-x-full w-64" : "translate-x-0 w-64"
                    : isSidebarCollapsed ? "w-20" : "w-64"}
                `}
              >
                <Sidebar
                  activeItem={activeItem}
                  onItemClick={handleSidebarClick}
                  isCollapsed={isSidebarCollapsed}
                  isMobile={isMobile}
                  closeSidebar={() => setIsSidebarCollapsed(true)}
                />
              </div>

              {/* OVERLAY (ONLY MOBILE) */}
              {isMobile && !isSidebarCollapsed && (
                <div
                  className="fixed inset-0 bg-black/40 z-40"
                  onClick={() => setIsSidebarCollapsed(true)}
                />
              )}
            </>
          )}

          {/* RIGHT SIDE LAYOUT */}
          <div
            className={`min-h-screen flex flex-col transition-all duration-300 ${
              showSidebar
                ? window.innerWidth <= 767 ? "" : isSidebarCollapsed ? "ml-20" : "ml-64"
                : ""
            }`}
          >
            {/* FIXED HEADER */}
            {showSidebar && (
              <div
                className={`
                  fixed top-0 right-0 z-30 transition-all duration-300
                  ${isMobile ? "left-0" : isSidebarCollapsed ? "left-20" : "left-64"}
                `}
              >
                <Header
                  isDragMode={isDragMode}
                  onToggleDragMode={() => setIsDragMode(!isDragMode)}
                  isSidebarCollapsed={isSidebarCollapsed}
                  onToggleSidebar={(value) => {
                    if (typeof value === "boolean") {
                      setIsSidebarCollapsed(value);
                    } else {
                      setIsSidebarCollapsed((prev) => !prev);
                    }
                  }}
                />
              </div>
            )}

            {/* SCROLLABLE CONTENT */}
            <main
              className={`flex-1 transition-all duration-300 ${
                showSidebar ? "pt-24 px-6 max-[567px]:px-2" : ""
              }`}
              style={{
                backgroundColor: colors.background,
                transition: "background-color 0.3s ease",
              }}
            >
              {/* Suspense context handles the dynamic runtime delivery of chunk components */}
              <Suspense fallback={<PageFallbackLoader />}>
                <Routes>
                  <Route path="/login" element={<Login />} />

                <Route
                  path="/resetpassword"
                  element={
                    <PrivateRoute>
                      <McCORD_Login />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <Home isDragMode={isDragMode} />
                    </PrivateRoute>
                  }
                />
                
                <Route
                  path="/waters"
                  element={
                    <PrivateRoute>
                      <Waters />
                    </PrivateRoute>
                  }
                />
                <Route path="/watersold" element={
                  <PrivateRoute>
                    < Watersold />
                  </PrivateRoute>
                } />
                <Route
                  path="/waterscombined"
                  element={
                    <PrivateRoute>
                      <WaterCombined />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/exemption"
                  element={
                    <PrivateRoute>
                      <DroughtExemption />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/drought-dashboard"
                  element={
                    <PrivateRoute>
                      <DroughtDashboard />
                    </PrivateRoute>
                  }
                />
  
                  <Route
                  path="/rule-configuration"
                  element={
                    <PrivateRoute>
                      <RuleConfigurations />
                    </PrivateRoute>
                  }
                />
                  <Route path="/violation-details" element={
                    <PrivateRoute>
                      <ViolationDetails />
                    </PrivateRoute>
                  } />

                    <Route path="/drought-report" element={
                    <PrivateRoute>
                      <DroughtReport />
                    </PrivateRoute>
                  } />
                
                <Route
                  path="/settingsuser"
                  element={
                    <PrivateRoute>
                      <Listuser />
                    </PrivateRoute>
                  }
                />
               
                <Route
                  path="/health"
                  element={
                    <PrivateRoute>
                      <Healthstatus />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/totalflow"
                  element={
                    <PrivateRoute>
                      <TotalFlow />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/flow-health"
                  element={
                    <PrivateRoute>
                      <FlowHealth />
                    </PrivateRoute>
                  }
                />
                
                <Route
                  path="/schematics"
                  element={
                    <PrivateRoute>
                      <Schematics />
                    </PrivateRoute>
                  }
                />
                
                <Route
                  path="/outliersnew"
                  element={
                    <PrivateRoute>
                      <Outliersnew />
                    </PrivateRoute>
                  }
                />
               
                <Route
                  path="/reset"
                  element={
                    <PrivateRoute>
                      <ResetPassword />
                    </PrivateRoute>
                  }
                />
                
                <Route
                  path="/profile"
                  element={
                    <PrivateRoute>
                      <Profile />
                    </PrivateRoute>
                  }
                />
               
                <Route
                  path="/alert"
                  element={
                    <PrivateRoute>
                      <Alerts />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/reportsandalerts"
                  element={
                    <PrivateRoute>
                      <ReportsAndAlerts />
                    </PrivateRoute>
                  }
                />
                
                <Route
                  path="/meter-leak-details"
                  element={
                    <PrivateRoute>
                      <MeterLeakDetail />
                    </PrivateRoute>
                  }
                />

                <Route
                  path="/leak-flow-category"
                  element={
                    <PrivateRoute>
                      <LeakFlowCategory />
                    </PrivateRoute>
                  }
                />

                  <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
              </Suspense>
            </main>
            {showSidebar && import.meta.env.VITE_CHATBOT_ENABLED === "true" && <ChatbotWidget />}
          </div>
        </DistrictProvider>
      </div>
    </DndProvider>
  );
}

export default App;
